"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixSchemaDefaultOptions = void 0;
exports.fixMinifiedSchema = fixMinifiedSchema;
exports.minifySchema = minifySchema;
exports.fixAndMergeSchema = fixAndMergeSchema;
function getRef(parent, url, root) {
    // currentContext = currentContext || this.schema;
    const turl = url.split('/');
    let start = 0;
    if (turl[0] === '#') {
        if (root === undefined) {
            // szukaj łażąc po parentach
            while (parent.$parent) {
                parent = parent.$parent;
            }
        }
        else {
            parent = root;
        }
        start++;
    }
    else if (turl[0] === '.') {
        if (parent.$parent) {
            parent = parent.$parent;
        }
        start++;
    }
    else {
        // coś tam innego
        if (parent.$parent) {
            parent = parent.$parent;
        }
    }
    // let turl = url.split("/");
    //let sparent2: any;
    for (let i = start; i < turl.length; i++) {
        // sparent2 = parent;
        if (turl[i]) {
            if (turl[i] === '..') {
                parent = parent.$parent;
            }
            else {
                parent = parent[turl[i]];
            }
            if (parent === undefined) {
                return null;
            }
        }
    }
    return parent;
}
exports.fixSchemaDefaultOptions = {
    arrayItemGuidField: null,
    model: null,
    minified: false
};
// eslint-disable-next-line no-useless-escape
const refRegex = /{{([a-z.\[\]\s\?\"\'\:\(\)\+]*)}}/gim;
/*
function isInDefinition(field: JSONSchema): boolean {
  const parent = field.$parent;
  if (field.$key === 'definitions') {
    if (parent && (parent.type === 'object' || parent.properties)) {
      return true;
    }
  }
  if (parent) {
    return isInDefinition(parent);
  }
  return false;
}
  */
function fixMinifiedSchema(schema) {
    const result = {};
    for (const key of Object.keys(schema)) {
        const value = schema[key];
        switch (key) {
            case 'defs':
                {
                    const defs = {};
                    for (const pkey of Object.keys(value)) {
                        defs[pkey] = fixMinifiedSchema(value[pkey]);
                    }
                    result.definitions = defs;
                    // type = undefined;;
                }
                break;
            // properties and items
            case 'p':
                {
                    const props = {};
                    for (const pkey of Object.keys(value)) {
                        props[pkey] = fixMinifiedSchema(value[pkey]);
                    }
                    result.properties = props;
                    result.type = 'object';
                }
                break;
            case 'i':
                {
                    result.items = fixMinifiedSchema(value);
                    result.type = 'array';
                }
                break;
            case 'd':
                result.default = value;
                break;
            case 'dsc':
                result.description = value;
                break;
            case 'r':
                result.required = value;
                break;
            case 'fr':
                result.fieldRequired = typeof value == 'string' ? value : !!value;
                break;
            case 'f':
                result.format = value;
                break;
            case 'ti':
                result.title = value;
                break;
            case 'w':
                result.warnings = value;
                break;
            case 't':
                switch (value) {
                    case 1:
                    case 'm':
                        result.type = 'money';
                        break;
                    case 2:
                    case 'i':
                        result.type = 'integer';
                        break;
                    case 3:
                    case 'n':
                        result.type = 'number';
                        break;
                    case 4:
                    case 'b':
                        result.type = 'boolean';
                        break;
                    case 5:
                    case 's':
                        result.type = 'string';
                        break;
                    default:
                        result.type = value;
                }
                break;
            default:
                result[key] = value;
                break;
        }
    }
    /*
    if (result.type === undefined) {
      result.type = "string";
    }
    */
    return result;
}
function minifySchema(schema) {
    const result = {};
    let type = schema.type;
    for (const key of Object.keys(schema)) {
        const value = schema[key];
        switch (key) {
            // properties and items
            case 'properties':
                {
                    const props = {};
                    for (const pkey of Object.keys(value)) {
                        props[pkey] = minifySchema(value[pkey]);
                    }
                    result.p = props;
                    type = undefined;
                }
                break;
            case 'definitions':
                {
                    const defs = {};
                    for (const pkey of Object.keys(value)) {
                        defs[pkey] = minifySchema(value[pkey]);
                    }
                    result.defs = defs;
                    // type = undefined;;
                }
                break;
            case 'default':
                result.d = value;
                break;
            case 'description':
                result.dsc = value;
                break;
            case 'items':
                result.i = minifySchema(value);
                type = undefined;
                break;
            case 'required':
                result.r = value;
                break;
            case 'fieldRequired':
                result.fr = typeof value === 'string' ? value : value ? 1 : 0;
                break;
            case 'format':
                result.f = value;
                break;
            case 'title':
                result.ti = value;
                break;
            case 'type':
                /*
                if (value === "string") {
                  type = undefined;
                }
                */
                break;
            case 'warnings':
                result.w = value;
                break;
            case '$id':
            case '$schema':
            case 'extends':
                break;
            default:
                result[key] = value;
                break;
        }
    }
    if (type) {
        switch (type) {
            case 'money':
                result.t = 1;
                break;
            case 'integer':
                result.t = 2;
                break;
            case 'number':
                result.t = 3;
                break;
            case 'boolean':
                result.t = 4;
                break;
            case 'string':
                result.t = 5;
                break;
            default:
                result.t = type;
                break;
        }
    }
    return result;
}
/**
 * Naprawia i łączy schematy
 * @param schemas schematy werjściowe
 * @param options opcje
 * @param parent element nadrzędny
 * @param root element root
 * @param mykey nazwa pola
 * @param fixType czy ma naprawiać typ pola jeśli brakuje
 */
function fixAndMergeSchema(schemas, options = exports.fixSchemaDefaultOptions, parent, root, mykey, fixType) {
    const props = {};
    const result = {};
    Object.defineProperty(result, '$key', {
        value: mykey || null
    });
    Object.defineProperty(result, '$parent', {
        value: parent || null
    });
    let refRoot = root;
    if (root === undefined || root === null) {
        root = result;
        refRoot = schemas[0];
    }
    /*
      if (mykey === 'definitions') {
          if (parent && (parent.type == 'object' || parent.properties) && schemas.length == 1) {
              return schemas[0];
          }
      }
      */
    let i = 0;
    while (i < schemas.length) {
        let schema = schemas[i];
        // while (true) {
        // rozwiązywanie allof w bieacym schemacie
        // allof
        const allOf = schema.allOf;
        if (allOf !== undefined) {
            const dschemas = [];
            // wszystkie schemas do tej pory
            for (let ii = 0; ii < i; ii++) {
                dschemas.push(schemas[ii]);
            }
            // moja schema
            dschemas.push(schema);
            // z allof
            // tslint:disable-next-line: prefer-for-of
            for (let ii = 0; ii < allOf.length; ii++) {
                dschemas.push(allOf[ii]);
            }
            // wszystkie pozostałe schemas
            for (let ii = i + 1; ii < schemas.length; ii++) {
                dschemas.push(schemas[ii]);
            }
            schemas = dschemas;
            schema = schemas[i];
        }
        // $ref
        let $ref = schema.$ref;
        if ($ref !== undefined) {
            if ($ref.indexOf('{{') > -1) {
                $ref = $ref.replace(refRegex, (match, fielddName) => {
                    if (!options.model) {
                        return '';
                    }
                    const funct = 'with(model) {return ' + fielddName + '}';
                    const func = new Function('model', funct);
                    try {
                        return func(options.model);
                    }
                    catch (err) {
                        if (process.env.NODE_ENV !== 'production') {
                            console.error(`[DEBUG] cannot calc $ref by ${fielddName}`, err);
                            // eslint-disable-next-line no-debugger
                            debugger;
                        }
                        return '';
                    }
                });
            }
            const refValue = getRef(result, $ref, refRoot);
            if (refValue !== null) {
                schemas[i] = schema = refValue;
            }
        }
        // } else {
        //    break;
        // }
        // }
        for (const key of Object.keys(schema)) {
            if (key === 'allOf') {
                continue;
            }
            const keyvalue = schema[key];
            if (keyvalue === null) {
                if (key !== 'default' && i > 0) {
                    delete props[key];
                    delete result[key];
                }
                else {
                    result[key] = null;
                }
            }
            else {
                if (key === 'default') {
                    result[key] = keyvalue;
                }
                else {
                    if (Array.isArray(keyvalue)) {
                        if (result[key] !== undefined && key === 'required') {
                            // łącz array
                            const darray = result[key].slice();
                            // tslint:disable-next-line: prefer-for-of
                            for (let ii = 0; ii < keyvalue.length; ii++) {
                                const avalue = keyvalue[ii];
                                if (darray.indexOf(avalue) === -1) {
                                    darray.push(avalue);
                                }
                            }
                            result[key] = darray;
                        }
                        else {
                            result[key] = keyvalue;
                        }
                    }
                    else if (typeof keyvalue === 'object') {
                        let proparray = props[key];
                        if (proparray === undefined) {
                            props[key] = proparray = [keyvalue];
                        }
                        else {
                            proparray.push(keyvalue);
                        }
                    }
                    else {
                        result[key] = keyvalue;
                    }
                }
            }
        }
        i++;
    }
    if (result.type === undefined) {
        if (fixType === true || fixType === undefined)
            if (props.properties !== undefined) {
                result.type = 'object';
            }
            else if (props.items !== undefined) {
                result.type = 'array';
            }
            else {
                // chodzi o to zeby nie dawało do enumeratora domyślnego typu, przydatne przy allOf
                Object.defineProperty(result, 'type', {
                    value: 'string'
                });
            }
        /*
            else if (!isInDefinition(result)) {
    
                result.type = 'string';
    
    
    
            }
            */
    }
    else if (result.type === 'int') {
        result.type = 'integer';
    }
    // fix guid field in array items
    /*
      if ((parent && parent.type === 'object') && (parent.$parent && parent.$parent.type === 'array')) {
  
      }
      */
    // dołaczanie wszystkich property
    // let propsCache: any = {};
    const fixChildType = mykey !== undefined && mykey === 'properties';
    // const cached2: any = {};
    const keys = Object.keys(props);
    for (const key of keys) {
        let cached;
        Object.defineProperty(result, key, {
            enumerable: true,
            configurable: true,
            get() {
                // delete result[key];
                // return result[key] =
                //   fixAndMergeSchema(props[key], options, result, root, key, fixChildType || (key === 'items'));
                return (cached ||
                    (cached = fixAndMergeSchema(props[key], options, result, root, key, fixChildType || key === 'items')));
            }
        });
    }
    if (result.type === 'object' && parent && parent.type === 'array' && options.arrayItemGuidField) {
        const pp = result.properties;
        if (pp && pp[options.arrayItemGuidField] === undefined) {
            let cached;
            Object.defineProperty(pp, options.arrayItemGuidField, {
                enumerable: true,
                configurable: true,
                get() {
                    if (cached) {
                        // console.log('schema cached property', key);
                        return cached;
                    }
                    else {
                        // console.log('schema get property', key);
                        return (cached = fixAndMergeSchema([
                            {
                                type: 'string',
                                format: 'guid'
                            }
                        ], options, pp, root, options.arrayItemGuidField, false));
                    }
                }
            });
            /*
                          pp[fixSchemaOptions.arrayItemGuidField] = {
                            type: 'string',
                            format: 'guid'
                          };
                          */
        }
    }
    return result;
}
exports.default = fixAndMergeSchema;
//# sourceMappingURL=fixAndMergeSchema.js.map